import Vue from 'vue';
import VueYoutube from 'vue-youtube';
import PortalVue from 'portal-vue';
import { BreakpointPlugin } from 'vue-breakpoint';
import detectIt from 'detect-it';
import App from './App.vue';
import router from './router';
import store from './store';
import Utilities from './utilities';
import './registerServiceWorker';

new Utilities();

Vue.use(VueYoutube);
Vue.use(PortalVue);
Vue.use(BreakpointPlugin);

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    data() {
        return {
            windowWidth: 0,
            windowHeight: 0,
            isTouch: false,
            mouseDown: 'mousedown',
            mouseMove: 'mousemove',
            mouseUp: 'mouseup',
            mouseOut: 'mouseout'
        };
    },
    beforeMount() {
        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);

        this.isTouch = this.isTouchDevice();
        this.setTouch();
    },
    mounted() {
        document.addEventListener('mousedown', this.onFirstInteraction);
        document.addEventListener('touchstart', this.onFirstInteraction);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
        window.removeEventListener('resize', this.getWindowHeight);
    },
    methods: {
        getWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
        getWindowHeigh() {
            this.windowHeight = document.documentElement.clientHeight;
        },
        isTouchDevice() {
            return detectIt.hasTouch; //'ontouchstart' in document.documentElement;
        },
        setTouch() {
            if (this.isTouch) {
                this.mouseDown = 'touchstart';
                this.mouseMove = 'touchmove';
                this.mouseUp = 'touchend';
                this.mouseOut = 'touchcancel';
            }
        },
        onFirstInteraction(e) {
            if (e instanceof TouchEvent) {
                this.isTouch = true;
            }
            document.removeEventListener('click', this.onFirstInteraction);
            document.removeEventListener('touchstart', this.onFirstInteraction);
            this.setTouch();
        }
    },
    render: h => h(App)
}).$mount('#app');
